// src/api/menu.ts
import request from '../utils/request'

// 获取菜单数据
export function getMenu() {
    return request({
        url: '/api/v1/admin/menu',
        method: 'get'
    })
}
